import { defineEnv } from "envin";
import * as z from "zod";

import { envConfig } from "@workspace/shared/constants";

import type { Preset } from "envin/types";

export const preset = {
  id: "paypal",
  server: {
    PAYPAL_CLIENT_ID: z.string().optional(),
    PAYPAL_CLIENT_SECRET: z.string().optional(),
    PAYPAL_ENV: z.enum(["sandbox", "live"]).optional(),
    PAYPAL_WEBHOOK_ID: z.string().optional(),
    PAYPAL_PLAN_ID_STARTER_MONTHLY: z.string().optional(),
    PAYPAL_PLAN_ID_STARTER_ANNUAL: z.string().optional(),
    PAYPAL_PLAN_ID_PROFESSIONAL_MONTHLY: z.string().optional(),
    PAYPAL_PLAN_ID_PROFESSIONAL_ANNUAL: z.string().optional(),
    PAYPAL_PLAN_ID_PRACTICE_MONTHLY: z.string().optional(),
    PAYPAL_PLAN_ID_PRACTICE_ANNUAL: z.string().optional(),
  },
} as const satisfies Preset;

export const env = defineEnv({
  ...envConfig,
  ...preset,
});
